export default {
    data() {
        return {
            center: {
                lat: parseFloat(this.postcodeDetails.latitude),
                lng: parseFloat(this.postcodeDetails.longitude)
            },
            zoom: 13,
            directionsDisplay: null
        }
    },
    mounted() {
        this.emitter.on('updateCenter', updatedCenter => {
            this.center = updatedCenter;
        });
    },
    updated() {

    },
    methods: {
        setBounds() {
            const mapRef = this.$refs.mapRef;
            const myMap = mapRef.map;
            const api = mapRef.api;
            const bounds = new api.LatLngBounds();
            
            this.garageFitters.forEach((fitter) => {
                bounds.extend(new api.LatLng(fitter.latitude, fitter.longitude));
            });
            
            myMap.fitBounds(bounds);
        },
        viewFitter(fitter_id, fitter_lat, fitter_long) {
            if(this.view == 'fitters' || this.view == 'fittedNationally') {
                //Clicking on map marker sets the selected fitter flag to true
                this.emitter.emit('selectFitter', fitter_id);
                
                if (!this.$refs.mapRef || !this.$refs.mapRef.map) {
                    return;
                }

                //Centers clicked marker on the map
                const myMap = this.$refs.mapRef.map;
                myMap.panTo({lat: parseFloat(fitter_lat), lng: parseFloat(fitter_long)});
                
                this.calculateDirections(fitter_lat, fitter_long, this.center);
            }
        },
        calculateDirections(fitter_lat, fitter_long, startPosition) {
            var vm = this;
            const mapRef = this.$refs.mapRef;
            const directionsService = new mapRef.api.DirectionsService();
            const fitter = new mapRef.api.LatLng(fitter_lat, fitter_long);

            if(this.directionsDisplay == null) {
                this.directionsDisplay = new mapRef.api.DirectionsRenderer();
            }

            this.directionsDisplay.setMap(mapRef.map);
            this.directionsDisplay.setOptions( { suppressMarkers: true } );

            var request = {
                origin: startPosition,
                destination: fitter,
                travelMode: mapRef.api.TravelMode.DRIVING,
                region: 'uk'
            };
    
            directionsService.route(request,function(result, status) {
                if(status == mapRef.api.DirectionsStatus.OK) {
                    vm.directionsDisplay.setDirections(result);
                }
            });
        },
        onTilesLoaded() {
            if (!this.garageFitters || !this.garageFitters[0]) {
                return false;
            }

            if (this.view === 'fitters' || this.view === 'fittedNationally') {
                this.setBounds();
            } else {
                this.calculateDirections(this.garageFitters[0].latitude, this.garageFitters[0].longitude, this.center)
            }
        }
    },
    computed: {
        garageFitters() {
            if (!this.fitters) return [];
            
            return this.fitters.filter((fitter) => {
                return fitter.mobile == 0;
            });
        }
    }
};